import useLocalStorage from '@/composables/local-storage/local-storage';
import useLoggedInUserAccount from '@/composables/logged-in-user-account/logged-in-user-account';
import { computed, ref } from 'vue';
import { createViewId } from '@/lib/saved-view/saved-view';

const sharedFlags = new Map();

const flagForKey = (key) => {
  if (!sharedFlags.has(key)) {
    const { data } = useLocalStorage(localStorage, { getKey: () => ref(key) }, false);
    sharedFlags.set(key, data);
  }
  return sharedFlags.get(key);
};

export default function useViewToolbarVisibility(currentView) {
  const { loggedInUserAccount } = useLoggedInUserAccount();
  const key = computed(() => `${loggedInUserAccount.value.uid}_view-toolbar_show_${createViewId(currentView.value)}`);

  const shown = computed({
    get: () => flagForKey(key.value).value,
    set: (value) => { flagForKey(key.value).value = value; },
  });

  return { shown };
}
